const STORAGE_KEY = 'safeguardpro_pack_audit_v1';

const readLogs = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeLogs = (logs) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
};

export default class PackAuditService {
  list() {
    return readLogs();
  }

  log({ packId, from, to, updatedBy }) {
    const entry = {
      id: `pack-audit-${Math.random().toString(36).slice(2, 9)}`,
      packId,
      from,
      to,
      updatedBy,
      updatedAt: new Date().toISOString()
    };
    const next = [entry, ...readLogs()];
    writeLogs(next);
    return entry;
  }
}
